import { render, staticRenderFns } from "./WizardDeferralOfPayment.vue?vue&type=template&id=45841810&"
import script from "./WizardDeferralOfPayment.vue?vue&type=script&lang=js&"
export * from "./WizardDeferralOfPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports